// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"c2-z","displaySixCardTiles":"d2-z"};